import React, { useMemo } from 'react';
import { cloneDeep } from 'lodash-es';
import { GameValidator } from '@colonist/game-mechanic-validators';
import { UIGameLog } from './UIGameLog/UIGameLog.tsx';
import { UIGameChat } from './UIGameChat/UIGameChat.tsx';
import { UIGameRushIntro } from './UIGameRushIntro/UIGameRushIntro.tsx';
import { useGameStore } from '../../store/GameStoreContext.ts';
export const UIGameFeedsPortrait = ({ visibility, onClickLog })=>{
    const gameState = useGameStore((state)=>state.gameState);
    const userStates = useGameStore((state)=>state.gameUserStates.userStates);
    const gameValidator = useMemo(()=>{
        const clonedGameState = cloneDeep(gameState);
        for(const playerColorKey in clonedGameState.playerStates){
            clonedGameState.playerStates[playerColorKey].isConnected = true;
        }
        return new GameValidator(gameState, userStates);
    }, []);
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(UIGameLog, {
        isLogVisible: visibility === 'log',
        gameValidator: gameValidator,
        backgroundColor: "blue",
        onClickLog: onClickLog
    }), /*#__PURE__*/ React.createElement(UIGameChat, {
        isChatVisible: visibility === 'chat',
        gameValidator: gameValidator,
        backgroundColor: "blue",
        isMinimizeable: false
    }), visibility === 'rush' && /*#__PURE__*/ React.createElement(UIGameRushIntro, {
        backgroundColor: "blue"
    }));
};
